import React, { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import { UserContext } from "../../hooks/UserContext";
import { FaDiscord, FaTiktok } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const { theme } = useContext(ThemeContext);
  const { user } = useContext(UserContext);

  const isDark = theme === "dark";
  const bg = isDark ? "#07070a" : "#ffffff";
  const g = "linear-gradient(135deg, #f43f5e 0%, #a855f7 50%, #6366f1 100%)";
  const muted = isDark ? "text-gray-500" : "text-gray-400";
  const linkCls = `text-sm py-1 block transition-colors ${isDark ? "text-gray-500 hover:text-white" : "text-gray-400 hover:text-gray-900"}`;

  return (
    <footer
      style={{ backgroundColor: bg }}
      className={`border-t ${isDark ? "border-white/[0.06] text-white" : "border-gray-100 text-gray-900"}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Col 1 — Brand */}
          <div className="flex flex-col gap-3">
            <Link to="/" className="inline-flex items-center gap-2 w-fit">
              <span
                className="h-1.5 w-1.5 rounded-full flex-shrink-0"
                style={{ background: g }}
              />
              <span
                className="font-black text-sm"
                style={{ letterSpacing: "-0.03em" }}
              >
                KRAYNE{" "}
                <span
                  className="bg-clip-text text-transparent"
                  style={{ backgroundImage: g }}
                >
                  AGENCY
                </span>
              </span>
            </Link>
            <p className={`text-sm leading-relaxed ${muted}`}>
              Studio digital — sites vitrines,
              <br />
              e-commerce et refonte.
            </p>
            <div className="flex items-center gap-2 pt-1">
              {[
                {
                  label: "Discord",
                  href: "https://discord.com/invite/4XbU25c87e",
                  Icon: FaDiscord,
                },
                {
                  label: "TikTok",
                  href: "https://www.tiktok.com/@krayne_off",
                  Icon: FaTiktok,
                },
              ].map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className={`h-8 w-8 rounded-lg flex items-center justify-center border text-xs transition-all ${
                    isDark
                      ? "border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.07] text-gray-500 hover:text-white"
                      : "border-gray-200 bg-gray-50 hover:bg-gray-100 text-gray-400 hover:text-gray-900"
                  }`}
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Navigation */}
          <div>
            <p
              className={`text-[10px] font-bold uppercase tracking-widest mb-3 ${isDark ? "text-gray-700" : "text-gray-300"}`}
            >
              Navigation
            </p>
            {[
              { label: "Accueil", to: "/" },
              { label: "Services", to: "/services" },
              { label: "Realisations", to: "/portfolio" },
              { label: "Tarifs", to: "/tarifs" },
              { label: "Contact", to: "/contact" },
            ].map((l) => (
              <Link key={l.to} to={l.to} className={linkCls}>
                {l.label}
              </Link>
            ))}
          </div>

          {/* Col 3 — Compte & Legal */}
          <div>
            <p
              className={`text-[10px] font-bold uppercase tracking-widest mb-3 ${isDark ? "text-gray-700" : "text-gray-300"}`}
            >
              Compte
            </p>
            {[
              { label: "Espace client", to: "/espace-client" },
              {
                label: user?.role === 3 ? "Tableau de bord" : null,
                to: "/dashboard",
              },
            ]
              .filter((l) => l.label)
              .map((l) => (
                <Link key={l.to} to={l.to} className={linkCls}>
                  {l.label}
                </Link>
              ))}
            <p
              className={`text-[10px] font-bold uppercase tracking-widest mt-5 mb-3 ${isDark ? "text-gray-700" : "text-gray-300"}`}
            >
              Legal
            </p>
            {[
              { label: "Mentions legales", to: "/mentions-legales" },
              { label: "CGV", to: "/cgv" },
            ].map((l) => (
              <Link key={l.to} to={l.to} className={linkCls}>
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        <div
          className={`mt-8 pt-5 border-t flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${
            isDark ? "border-white/[0.05]" : "border-gray-100"
          }`}
        >
          <p
            className={`text-xs ${isDark ? "text-gray-700" : "text-gray-400"}`}
          >
            &copy; 2026 Krayne Agency. Tous droits reserves.
          </p>
          <div className="flex flex-wrap gap-5">
            {[
              { label: "Services", to: "/services" },
              { label: "Portfolio", to: "/portfolio" },
              { label: "Contact", to: "/contact" },
              { label: "Mentions legales", to: "/mentions-legales" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`text-xs transition-colors ${
                  isDark
                    ? "text-gray-700 hover:text-gray-400"
                    : "text-gray-400 hover:text-gray-700"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
